import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store"

declare var window:any

import globalMU from "globalMU";
import {IItemOrcamento} from "../../types/IItemOrcamento";

export type AlterarTipoEntregaParams = {
    alterarTipoEntregaPadraoOrcamento: boolean, // 474918
    itens: IItemOrcamento[],
    tipoEntrega: string
}

export type AlterarTipoEntregaOutput = {
    status: "SUCESSO" | "ERRO"
}

export async function alterarTipoEntregaItens(params: AlterarTipoEntregaParams) : Promise<AlterarTipoEntregaOutput> {
    try {
        globalMU.blockUI({tryPassiveLoading: true})
        
        const orcamentoAtualizado = await microuniversoApi.Orcamento.alterarTipoEntregaItens(
            store.getState().orcamento.IdentificadorOrcamento,
            params.alterarTipoEntregaPadraoOrcamento, // 474918
            params.tipoEntrega,
            params.itens
        )
    
        const orcamentoLegado = window.orcamentoController.model

        orcamentoLegado.atualizar(orcamentoAtualizado)
        
        return {
            status: "HasErrors" in orcamentoAtualizado ? "ERRO" : "SUCESSO"
        }
        
    } finally {
        globalMU.unblockUI()
    }

    
}
